import React from "react";
import { Link } from "react-router-dom";

import aboutImg from "../../assets/images/about/ab.png";
import shapeImg from "../../assets/images/about/badge.png";

const AboutPart = () => {
  return (
    <div style={{ paddingBottom: "70px" }}>
      <div className="about__area about__area_one p-relative pt---20">
        <div className="container">
          <div className="row">
            {/* <div className="col-lg-6">
              <div
                className="about__image wow animate__fadeInUp"
                data-wow-duration="0.3s"
              >
                <img src={aboutImg} alt="About" />
                <img
                  className="react__shape__abc"
                  src={shapeImg}
                  alt="Shape Image"
                  style={{borderRadius:"50%"}}
                />
              </div>
            </div> */}
            <div>
              <div className="about__content">
                <h2
                  className="about__title wow animate__fadeInUp"
                  data-wow-duration="0.3s"
                >
                  About <em>IAS Jnani</em>
                </h2>
                <p
                  className="about__paragraph wow animate__fadeInUp"
                  data-wow-duration="0.5s"
                >
                  IAS Jnani, the flagship brand of Jnani Educational Pvt. Ltd.,
                  is not just a UPSC coaching institute—it’s a mission-driven
                  movement to empower future civil servants. At IAS Jnani, we
                  believe UPSC preparation should be transformative, not
                  transactional. That's why we've developed a battle-tested
                  strategy that breaks away from the conventional grind.
                </p>
                <p
                  className="about__paragraph wow animate__fadeInUp"
                  data-wow-duration="0.6s"
                >
                  Our approach is more than just completing the syllabus—it's
                  about understanding, internalizing, and mastering every aspect
                  of it. Through a meticulously crafted curriculum, personalized
                  mentorship, and real-time performance tracking, we ensure that
                  every student walks the path to success with clarity and
                  confidence.
                </p>
                <p
                  className="about__paragraph wow animate__fadeInUp"
                  data-wow-duration="0.7s"
                >
                  At IAS Jnani, we eliminate the fluff. No outdated materials,
                  no irrelevant content—only sharp, precise, and effective
                  preparation tailored for the modern UPSC aspirant. Our goal is
                  not just to teach, but to build a mindset that thrives under
                  pressure and performs when it matters most.
                </p>
                <p className="wow animate__fadeInUp" data-wow-duration="0.8s">
                  Join us and be a part of a new era in civil services
                  preparation. With IAS Jnani, you're not just preparing for an
                  exam—you're preparing to lead, serve, and inspire.
                </p>
                <ul className="wow animate__fadeInUp" data-wow-duration="0.9s">
                  <li>
                    <Link to="/course" className="more-about">
                      {" "}
                      Read More{" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="feather feather-arrow-right"
                      >
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                      </svg>
                    </Link>
                  </li>
                  <li className="last-li">
                    <em>Get Support</em>
                    <Link to="mailto:contact@iasjnani.com">
                      contact@iasjnani.com
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPart;
